import { useState } from "react";
import { Link } from "react-router-dom";
import { LogOut, ExternalLink } from "lucide-react";
import BrandsManager from "./BrandsManager";
import YachtsManager from "./YachtsManager";
import EnquiriesList from "./EnquiriesList";
import HeroSlidesManager from "./HeroSlidesManager";

const TABS = [
  { key: "yachts", label: "Yacht Models" },
  { key: "brands", label: "Brand Partners" },
  { key: "hero", label: "Homepage Hero" },
  { key: "enquiries", label: "Enquiries" },
];

export default function AdminShell({ admin, onLogout }) {
  const [tab, setTab] = useState("yachts");

  return (
    <div className="min-h-screen bg-navy" data-testid="admin-dashboard">
      <header className="border-b border-navy-ink/10 bg-navy-light/60 px-6 py-5 lg:px-12">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4">
          <div>
            <p className="text-[10px] uppercase tracking-[0.45em] text-gold">Private Office</p>
            <h1 className="mt-1 flex items-center gap-3 font-serif text-2xl text-navy-ink">
              <img src="/modi-marine-logo.png" alt="Modi Marine" className="h-6 w-auto" /> <span className="text-mist">— Catalogue</span>
            </h1>
          </div>
          <div className="flex items-center gap-4 text-[10px] uppercase tracking-[0.3em] text-mist">
            <span data-testid="admin-user-email">{admin.email}</span>
            <Link to="/yachts" target="_blank" className="inline-flex items-center gap-1 hover:text-gold" data-testid="admin-view-site-link">
              View site <ExternalLink size={12} />
            </Link>
            <button onClick={onLogout} className="inline-flex items-center gap-1 hover:text-gold" data-testid="admin-logout-button">
              Sign out <LogOut size={12} />
            </button>
          </div>
        </div>
      </header>

      <div className="mx-auto max-w-7xl px-6 py-10 lg:px-12">
        <nav className="mb-10 flex gap-2 border-b border-navy-ink/10" data-testid="admin-tabs">
          {TABS.map((t) => (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              data-testid={`admin-tab-${t.key}`}
              className={`-mb-px border-b-2 px-5 py-3 text-[11px] uppercase tracking-[0.3em] transition-colors ${
                tab === t.key ? "border-gold text-gold" : "border-transparent text-mist hover:text-navy-ink"
              }`}
            >
              {t.label}
            </button>
          ))}
        </nav>
        {tab === "yachts" && <YachtsManager />}
        {tab === "brands" && <BrandsManager />}
        {tab === "hero" && <HeroSlidesManager />}
        {tab === "enquiries" && <EnquiriesList />}
      </div>
    </div>
  );
}
